import {
  Pagination,
  InlineFilter,
  BackgroundIcon,
  Loader,
  isAuthorised
} from '@nile/components';
import {
  DateTimeCell,
  DependantCell,
  DualCell,
  HTMLCell,
  SubjectCell,
  LinkCell,
  NameCell,
  PriorityCell,
  StepCell,
  TagCell,
  TextCell,
  TimerCell,
  ProgressCell,
  CustomTimeCell,
  CustomTextCell,
  CustomRadioCell,
  CustomCheckboxCell,
  CustomSelectCell,
  HoursMinutesCell,
  CustomSecureTextCell
} from '@nile/mangifera/src/Components/Ticket';
// import InlineEditTextCell from '@nile/mangifera/src/Components/Ticket/InlineEditTextCell';
import InlineEditTextCellV2 from '@nile/mangifera/src/Components/Ticket/InlineEditTextCellV2';
import InlineStatusCell from '@nile/mangifera/src/Components/Ticket/InlineStatusCell';
// import InlineEditDualCell from '@nile/mangifera/src/Components/Ticket/InlineEditDualCell';
import InlineEditDualCellV2 from '@nile/mangifera/src/Components/Ticket/InlineEditDualCellV2';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { SortDown, SortUp } from '@styled-icons/boxicons-regular';
import PropTypes from 'prop-types';
import React, { useState, useCallback, useContext, useEffect } from 'react';
import {
  useFlexLayout,
  useGlobalFilter,
  usePagination,
  useResizeColumns,
  useRowSelect,
  useTable,
  useFilters
} from 'react-table';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import NewInlineStatusCell from '@nile/mangifera/src/Components/Ticket/NewInlineStatusCell';
import { SVGIcon } from '@superops/super-icons';

const Styles = styled.div`
  .table-content {
    height: calc(100% - 50px); //reduce header height
    ${({ tableSpace }) =>
      tableSpace &&
      `
      /* Add left space for inside asset details */
      .unFreezeContent > div > .td:nth-child(1) {
        padding-left: 35px;
      }
    `}
  }

  ${({ tableSpace }) =>
    tableSpace &&
    `
    /* Add left space for inside asset details */
    .unfreezeHeader > div:nth-child(1) > .th:nth-child(1) {
      padding-left: 35px;
    }
  `}

  .columHeader {
    min-height: 50px;
    height: auto !important;
  }
  .table > div:first-child > div:first-child {
    display: none !important;
  }
  .unfreezeContent {
    align-items: flex-start;
    position: relative;
  }
  /* Hide scrollbar for Chrome, Safari and Opera */
  .unfreezeHeader::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .unfreezeHeader {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .columnHeader {
    width: 100%;
  }

  .colHeader {
    text-transform: uppercase;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    background: var(--sops-table-bg);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    height: 50%;
    margin: 4px 0;
    margin-top: 15px;
  }

  .tbody {
    .tr:hover {
      .td {
        background: #f5f5fc;
      }
      .editable-cell {
        background: #fff;
        border: 1px solid #d4d4d4;
      }
      .edit-actions {
        visibility: visible;
      }
    }
    .editable-cell {
      border-radius: 4px;
      height: 80%;
      font-weight: normal !important;
      border: 1px solid transparent;
    }
    .td {
      background: var(--sops-table-bg);
      align-items: center !important;
      border-bottom: 1px solid transparent;
    }
  }

  .resizer {
    display: inline-block;
    //background: #ececec;
    width: 5px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(50%);
    z-index: 1;
    ${'' /* prevents from scrolling while dragging on touch devices */}
    touch-action:none;

    &.isResizing {
      background: red;
    }
  }
  .unfreezeContent {
    align-items: flex-start;
    position: relative;
  }
  height: 100%;
  .table {
    height: calc(100% - 46px);
    padding-bottom: 10px;
  }
  ${({ tableSpace }) =>
    tableSpace &&
    `
      .Table__pagination {
        padding-left: 22px;
      }
  `}
`;

const SortUpIcon = styled(SortUp)`
  width: 20px;
  height: 20px;
`;

const SortDownIcon = styled(SortDown)`
  width: 20px;
  height: 20px;
`;

const Header = styled.div`
  font-weight: ${(props) => (props.isSorted ? '500' : 'normal')};
  cursor: ${(props) => (props.canSort ? 'pointer' : 'auto')};
  display: flex;
  align-items: center;
  margin-right: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const TableHeaderWrapper = styled.div`
  padding-left: 4px;
  min-height: 100%;
  .filter-icon {
    margin-left: auto;
    margin-right: 2px;
    visibility: hidden;
    cursor: pointer;
  }
  .icon {
    visibility: hidden;
    cursor: pointer;
  }
  .action-button {
    visibility: hidden;
  }
  &:hover {
    .filter-icon {
      visibility: visible;
    }
    .action-button {
      visibility: visible;
    }
    .icon {
      visibility: visible;
    }
  }
`;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, row, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    const referenceRole = row?.original?.followerPermission
      ? JSON.parse(row?.original?.followerPermission)
      : null;
    const isEditAuthorised = referenceRole
      ? isAuthorised(referenceRole, 'tickets.edit')
      : true;

    const checkBoxDisabled =
      !isEditAuthorised &&
      rest?.checkBoxDisabledCheck &&
      rest?.checkBoxDisabledCheck(rest?.row?.original);
    return (
      <>
        <input
          type="checkbox"
          ref={resolvedRef}
          {...rest}
          disabled={checkBoxDisabled}
        />
      </>
    );
  }
);

const defaultColumn = {
  minWidth: 30,
  maxWidth: 500,
  width: 150,
  Link: LinkCell,
  Priority: PriorityCell,
  HTML: SubjectCell,
  Text: InlineEditTextCellV2,
  Timer: TimerCell,
  Status: NewInlineStatusCell,
  DateTime: DateTimeCell,
  Dependant: InlineEditTextCellV2,
  Dual: InlineEditDualCellV2,
  Step: StepCell,
  Name: NameCell,
  Progress: ProgressCell,
  CustomTime: CustomTimeCell,
  CustomText: CustomTextCell,
  CustomRadio: CustomRadioCell,
  CustomCheckbox: CustomCheckboxCell,
  CustomSelect: CustomSelectCell,
  SecureText: CustomSecureTextCell,
  HoursMinutes: HoursMinutesCell
};

const cellProps = (props, { cell }) => getStyles(props, cell.column.align);

const getStyles = (props, align = 'left') => [
  props,
  {
    style: {
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      alignItems: 'flex-start',
      display: 'flex'
    }
  }
];

function FilterCell(props) {
  const { column, context } = props;
  return (
    <InlineFilter
      allConditions={context.viewConditions}
      meta={{ ...column.helpers, field: column.field, entity: 'Ticket' }}
    />
  );
}

function TableHeaders(props) {
  const {
    column,
    context,
    refreshTable,
    rowCount,
    pageNumber,
    listInfo,
    showFilters,
    toggleFilters
  } = props;
  const getAttributeName = () => {
    switch (column?.field?.name) {
      case 'prioritizedId':
        return 'displayId';
      case 'client':
        return 'client.name';
      case 'site':
        return 'site.name';
      case 'requester':
        return 'requester.name';
      case 'technician':
        return 'technician.name';
      case 'techGroup':
        return 'techGroup.name';
      case 'firstResponseTimer':
        return 'firstResponseDueTime';
      case 'resolutionTimer':
        return 'resolutionDueTime';
      case 'sla':
        return 'sla.name';
      default:
        return column?.field?.name;
    }
  };
  const sortCurrentColumn = () => {
    if (column.disableSortBy) return;
    const attributeName = getAttributeName();
    refreshTable(context.personalization, {
      pageSize: rowCount,
      page: 1,
      sort:
        listInfo?.sort?.[0]?.order === 'DESC'
          ? listInfo?.sort?.[0]?.attribute === attributeName
            ? null
            : [
                {
                  attribute: attributeName,
                  order: 'ASC'
                }
              ]
          : [
              {
                attribute: attributeName,
                order:
                  listInfo?.sort?.[0]?.attribute === attributeName
                    ? listInfo?.sort?.[0]?.order === 'ASC'
                      ? 'DESC'
                      : 'ASC'
                    : 'ASC'
              }
            ]
    });
  };
  const attributeName = getAttributeName();
  const isSorted = listInfo?.sort?.[0].attribute === attributeName;
  const isFiltered =
    context?.viewConditions?.operands?.findIndex((el) =>
      column?.field?.dataType === 'entity'
        ? el.attribute === `${column?.field?.name}.name`
        : el.attribute && el.attribute === column?.field?.name
    ) > -1;
  const isSortedDesc = listInfo?.sort?.[0].order === 'DESC';
  return (
    <TableHeaderWrapper
      className="inblock"
      {...(column.id === 'selection'
        ? column.getHeaderProps()
        : column.getHeaderProps())}
    >
      <div
        className={`fx ${column.id !== 'selection' ? 'th colHeader' : 'fx'}`}
      >
        {column.id === 'selection' ? (
          <div className="mt-15">{column.render('Header')}</div>
        ) : (
          <Header
            isSorted={isSorted}
            canSort={!column.disableSortBy}
            onClick={sortCurrentColumn.bind(this, column)}
          >
            {column?.field?.label || 'NA'}
          </Header>
        )}
        {column.canResize && (
          <div
            {...column.getResizerProps()}
            className={`resizer ${column.isResizing ? 'isResizing' : ''}`}
          />
        )}
        {column.id !== 'selection' && isSorted ? (
          <div
            active={column.isSorted}
            onClick={sortCurrentColumn.bind(this, column)}
          >
            {isSortedDesc ? <SortDownIcon /> : <SortUpIcon />}
          </div>
        ) : (
          column.id !== 'selection' &&
          !column.disableSortBy && (
            <div
              className="icon"
              onClick={sortCurrentColumn.bind(this, column)}
            >
              <SortUpIcon />
            </div>
          )
        )}
        {(column.canFilter || isFiltered) && (
          <FilterIcon className="filter-icon" active={isFiltered}>
            <div onClick={toggleFilters} className="fx center">
              <SVGIcon name="Filter" />
            </div>
          </FilterIcon>
        )}
      </div>
      {column.id !== 'selection' && column.canFilter && showFilters && (
        <div>
          <FilterCell column={column} context={context} />
        </div>
      )}
    </TableHeaderWrapper>
  );
}

const TicketTable = (props) => {
  const {
    columns,
    data,
    pagination,
    setData,
    updateMyData,
    skipPageReset,
    refreshTable,
    rowCount,
    setSelectedRows,
    pages,
    listInfo,
    activePage,
    noBulkSelect,
    recordCount,
    isLoading,
    checkBoxDisabledCheck,
    accessAssetDetails = false
  } = props;
  const {
    getTableProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    setPageSize,
    canPreviousPage,
    previousPage,
    nextPage,
    canNextPage,
    pageCount,
    pageOptions,
    selectedFlatRows,
    toggleAllRowsSelected,
    state: { pageIndex, pageSize, selectedRowIds, sortBy }
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      autoResetPage: !skipPageReset,
      updateMyData,
      refreshTable,
      manualFilters: true
      // disableSortBy: true
    },
    useResizeColumns,
    useGlobalFilter,
    useFilters,
    usePagination,
    useRowSelect,
    useFlexLayout,
    (hooks) => {
      if (!noBulkSelect) {
        hooks.allColumns.push((columns) => [
          {
            id: 'selection',
            disableResizing: true,
            minWidth: 35,
            width: 35,
            maxWidth: 35,
            Header: ({ getToggleAllRowsSelectedProps }) => {
              return (
                <div>
                  <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                </div>
              );
            },
            Cell: ({ row }) => (
              <div>
                <IndeterminateCheckbox
                  {...row.getToggleRowSelectedProps()}
                  row={row}
                  checkBoxDisabledCheck={checkBoxDisabledCheck}
                />
              </div>
            )
          },
          ...columns
        ]);
        hooks.useInstanceBeforeDimensions.push(({ headerGroups }) => {
          // fix the parent group of the selection button to not be resizable
          const selectionGroupHeader = headerGroups[0].headers[0];
          selectionGroupHeader.canResize = false;
        });
      }
    }
  );
  const freezedColumns = React.useRef(0);
  const normalcolumns = React.useRef(1);
  const normalColHeaders = React.useRef(2);

  const context = props.context || useContext(TicketContext);
  const [showFilters, setShowFilters] = useState(!!context.viewConditions);
  const [tableHeight, setTableHeight] = useState(null);
  const toggleFilters = useCallback(() => {
    setShowFilters(!showFilters);
  });
  const scollTableBody = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (
      !(
        e.target === freezedColumns.current ||
        e.target === normalColHeaders.current ||
        e.target === normalcolumns?.current
      )
    ) {
      return;
    }
    const scrollElement =
      e.target === freezedColumns.current ? normalcolumns : freezedColumns;
    if (scrollElement.current)
      scrollElement.current.scrollTop = e.target.scrollTop;
    if (normalColHeaders.current)
      normalColHeaders.current.scrollLeft = e.target.scrollLeft;
    if (e.target === normalColHeaders.current)
      normalcolumns.current.scrollLeft = e.target.scrollLeft;
  };

  useEffect(() => {
    const rows = [];
    for (let i = 0; i < selectedFlatRows.length; i++) {
      if (
        !selectedFlatRows[i].original.followerPermission ||
        (selectedFlatRows[i]?.original?.followerPermission &&
          JSON.parse(
            selectedFlatRows[i]?.original?.followerPermission
          ).Tickets.indexOf('Edit') > -1)
      ) {
        rows.push(selectedFlatRows[i].original);
      }
    }
    context.setRecords && context.setRecords(rows);
  }, [selectedRowIds]);

  useEffect(() => {
    setPageSize(rowCount);
  }, [rowCount]);

  useEffect(() => {
    setPageSize(rowCount);
  }, []);

  useEffect(() => {
    if (context?.records?.length !== selectedFlatRows.length) {
      // FIX: When selected records are present while searching
      // We'll remove the selected records from the context
      // which triggers this useEffect without conditions and also triggers another with filter condition
      // To fix this I've Appended the conditions from listinfo and passed as params in refreshTable
      // We need to find a way to prevent 2 APIs being called
      const filterConditions = context?.viewConditions
        ? { condition: context?.viewConditions }
        : {};
      const params = listInfo ? { ...listInfo, ...filterConditions } : null;
      refreshTable(context.personalization, params);
      if (!context?.records?.length) toggleAllRowsSelected(false);
    }
  }, [context.records]);

  useEffect(() => {
    if (
      normalColHeaders?.current?.offsetHeight &&
      tableHeight !== normalColHeaders?.current?.offsetHeight
    ) {
      setTableHeight(normalColHeaders.current.offsetHeight);
    }
  }, [normalColHeaders?.current?.offsetHeight]);

  const navigatePages = useCallback((pageNumber) => {
    console.log('calling', pageNumber);
    refreshTable(context.personalization, {
      pageSize: rowCount,
      page: pageNumber || 0,
      sort: listInfo.sort || null
    });
  });
  // Render the UI for your table
  return (
    <Styles tableSpace={accessAssetDetails}>
      <div {...getTableProps()} className="table">
        <div>
          {headerGroups.map((headerGroup) => (
            <div {...headerGroup.getHeaderGroupProps()} className="tr">
              <div className="fx columHeader">
                {/* <div className="fx fh actr freezeContent">
                  {headerGroup.headers.map((column, i) => {
                  if(i < 3)
                  return (
                    <TableHeaders column={column}></TableHeaders>
                  )
                  })}
                </div>
                <div className="fx fh actr rShad freezePan">
                </div> */}
                <div
                  className="unFreezeContent fx fh actr unfreezeHeader"
                  onScroll={scollTableBody}
                  ref={(node) => {
                    normalColHeaders.current = node;
                  }}
                >
                  {headerGroup.headers.map((column, i) => {
                    //if(i > 3)
                    return (
                      <TableHeaders
                        showFilters={showFilters}
                        toggleFilters={toggleFilters}
                        pageNumber={pageIndex}
                        refreshTable={refreshTable}
                        column={column}
                        rowCount={rowCount}
                        context={context}
                        listInfo={listInfo}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="table-content">
          {/* <div className="tbody rShad" onScroll={scollTableBody} ref={freezedColumns}>
            {page.map((row, i) => {
              prepareRow(row)
               return (
                <div {...row.getRowProps()} className="tr">
                  {row.cells.map((cell, j) => {
                    if(j < 3) return (
                      <div {...cell.getCellProps(cellProps)} className="td">
                        {!cell.value ? cell.render('Cell') : cell.render(cell.render(cell.column.type))}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div> */}
          <TableBodyWrapper
            className="tbody unFreezeContent"
            onScroll={scollTableBody}
            maxHeight={tableHeight}
            ref={normalcolumns}
          >
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} className="tr" isLoading={isLoading}>
                  {row.cells.map((cell, j) => {
                    //if(j > 3)
                    return (
                      <div
                        id={i}
                        {...cell.getCellProps(cellProps)}
                        className="td sops-list-cell"
                      >
                        {cell.column.hasOwnProperty('type')
                          ? cell.render(cell.column.type)
                          : cell.render('Cell')}
                      </div>
                    );
                  })}
                </Tr>
              );
            })}
            {/* <OverlayLoading
              isLoading={isLoading}
              height={getOverlayHeight(normalcolumns)}
              width={getOverlayWidth(normalcolumns)}
            > */}
            {/* {isLoading && (
              <Overlay>
                <Loader />
              </Overlay>
            )} */}
            {/* </OverlayLoading> */}
          </TableBodyWrapper>
        </div>
      </div>
      {pagination && (
        <Pagination
          // canPreviousPage={canPreviousPage}
          // canNextPage={canNextPage}
          onPageChange={navigatePages}
          // pageCount={pageCount}
          // pageOptions={pageOptions}
          // pageIndex={pageIndex}
          // pageSize={pageSize}
          // previousPage={previousPage}
          // nextPage={nextPage}
          setPageSize={setPageSize}
          rowCount={rowCount}
          recordCount={recordCount}
          pages={pages}
          page={activePage}
        />
      )}
    </Styles>
  );
};

const FilterIcon = styled.div`
  visibility: ${(props) => (props.active ? 'visible' : '')} !important;
`;

const TableBodyWrapper = styled.div`
  max-height: ${(props) =>
    props.maxHeight
      ? `calc(100% - ${props.maxHeight - 50}px)`
      : 'calc(100% - 50px)'} !important;
`;

const Tr = styled.div`
  opacity: ${(props) => (props.isLoading ? '0.4' : '1')};
  transition: opacity 200ms linear;
  pointer-events: ${(props) => (props.isLoading ? 'none' : 'all')};
`;

TicketTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  updateMyData: PropTypes.func.isRequired,
  setData: PropTypes.func.isRequired,
  skipPageReset: PropTypes.bool.isRequired
};

export default TicketTable;
